import { useCallback, useState } from 'react';

import { identityHttpClient } from '@/services/http/clients/identityHttpClient';
import { User } from './responseModels/user';

export type SearchUsersInput = {
  ids?: UUID[],
  searchName?: string | undefined,
};

export function useSearchUsers() {
  const [isLoadingSearchUsers, setIsLoadingSearchUsers] = useState(false);
  
  const searchUsers = useCallback(async (searchUsersInput: SearchUsersInput) => {
    setIsLoadingSearchUsers(true);
    const requestUrl = '/user/search';
    const response = await identityHttpClient.post<User[]>(requestUrl, searchUsersInput);
    setIsLoadingSearchUsers(false);
    return response.data;
  }, []);

  return {
    searchUsers,
    isLoadingSearchUsers: isLoadingSearchUsers,
  } as const;
}